import { FilesService } from '@app/pages/cmms/services/files.service';
import { IActionCenterSuggester } from '../../interfaces';
import { first, lastValueFrom, map, take } from 'rxjs';
import { FileAiSuggestionService } from '@app/pages/files/services/file-ai-suggestion.service';
import { applyFileTaggingRules } from '@app/pages/cmms/graphql/files.mutations';
import { Apollo } from 'apollo-angular';
import { IconSnackBarService } from '@app/core/services/icon-snack-bar.service';
import { ActionCenterService } from '@app/core/services/action-center.service';
import { TranslateService } from '@tolgee/ngx';

export class ClassificationSuggester implements IActionCenterSuggester {
	private readonly filesService: FilesService;
	private readonly fileAiSuggestionService: FileAiSuggestionService;

	constructor(deps: {
		filesService: FilesService;
		fileAiSuggestionService: FileAiSuggestionService;
	}) {
		this.filesService = deps.filesService;
		this.fileAiSuggestionService = deps.fileAiSuggestionService;
	}

	suggest(selectedPks: string[]): Promise<any> {
		const obs = this.filesService
			.startAiClassificationSuggestionJob(selectedPks)
			.pipe(first());

		obs.subscribe(res => {
			this.fileAiSuggestionService.suggestionStarted$.next(res);
		});

		return lastValueFrom(obs);
	}
}

export class FileTaggingSuggester implements IActionCenterSuggester {
	private readonly apollo: Apollo;
	private readonly notify: IconSnackBarService;
	private readonly actionCenterService: ActionCenterService;
	private readonly translateService: TranslateService;

	constructor(deps: {
		apollo: Apollo;
		actionCenterService: ActionCenterService;
		notify: IconSnackBarService;
		translateService: TranslateService;
	}) {
		this.apollo = deps.apollo;
		this.actionCenterService = deps.actionCenterService;
		this.notify = deps.notify;
		this.translateService = deps.translateService;
	}

	suggest(selectedPks: string[]): Promise<any> {
		const obs = this.apollo
			.mutate<{
				success: boolean;
			}>({
				mutation: applyFileTaggingRules,
				variables: { filePks: selectedPks },
			})
			.pipe(map(res => res.data));

		obs.pipe(take(1)).subscribe(() => {
			this.notify.success(this.translateService.instant('success_auto_tagging'));
			this.actionCenterService.actionDone$.next();
		});

		return lastValueFrom(obs);
	}
}
